import React, { useState, useEffect } from 'react';
import { AsyncStorage } from 'services';
import queryString from 'query-string';
import { webAppRoot, chromeExtensionId, isChromeExtension } from 'helpers/constants';
import axios from 'axios';
import { apiEndpoints } from 'helpers/endpoints';
import { useParams } from 'react-router-dom';
import styles from './ImpersonateScreen.module.scss';
import { DashboardHeading, Button, Loader } from 'components/shared';
import { useTranslation } from 'react-i18next';

export const ImpersonateScreen = () => {
  const { accessToken } = useParams();

  const startFlow = async () => {
    sessionStorage.setItem('impersonateModeActive', 'true');
    sessionStorage.setItem('accessToken', accessToken as string);
    sessionStorage.setItem('refreshToken', '000000'); // used to timeout the session after accessToken expires

    if (isChromeExtension) {
      chrome.tabs.query({ active: true, currentWindow: true }, function (tabs: any) {
        chrome.tabs.reload(tabs[0].id);
      });
    } else {
      window.location.href = '/app';
    }
  };

  const redirectAfterSave = async () => {
    const impersonateModeActive = await AsyncStorage.get('impersonateModeActive');
    if (isChromeExtension && impersonateModeActive) {
      window.location.href = '/index.html#/app/';
    }
  };

  useEffect(() => {
    redirectAfterSave();
  }, []);

  useEffect(() => {
    if (queryString) {
      startFlow();
    } else {
      window.close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export const ImpersonateModal = () => {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [connecting, setConnecting] = useState(false);
  const [problem, setProblem] = useState(false);
  const { t } = useTranslation();

  function openInNewTab(url: string) {
    var win: any = window.open(url, '_blank');
    win.focus();
  }

  const handleSubmit = async (evt: any) => {
    setConnecting(true);
    setProblem(false);
    evt.preventDefault();

    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'FYI-Authorization': 'Bearer ' + (await AsyncStorage.get('accessToken')),
      },
    };

    await axios
      .post(apiEndpoints.impersonate, { email: email,  comment: reason  }, headers)
      .then((response) => {
        let redirectUrl;
        if (isChromeExtension) {
          redirectUrl =
            'chrome-extension://' +
            chromeExtensionId +
            '/index.html#/app/impersonate/' +
            response?.data?.access_token;
        } else {
          redirectUrl = webAppRoot + 'impersonate/' + response?.data?.access_token;
        }
        openInNewTab(redirectUrl);
        setConnecting(false);
      })
      .catch(() => {
        setConnecting(false);
        setProblem(true);
        return false;
      });
  };

  return (
    <div style={{ padding: 20 }}>
      <div className={styles.sectionHeading}>
        <DashboardHeading level={1}>Impersonate: </DashboardHeading>
      </div>
      <form onSubmit={handleSubmit}>
        <input
          className={styles.inputField}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className={styles.inputField}
          type="string"
          placeholder="reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <div>
          <Button
            className={styles.submitButton}
            onClick={handleSubmit}
            type={'Primary'}
            disabled={email.length === 0 || reason.length === 0}
          >
            {connecting ? <Loader color="White" width={30} height={30} /> : 'Start'}
          </Button>
        </div>
        {problem && (
          <div className={styles.footer}>
            <div className={styles.footerText}>{t('toasts.impersonate-issue')}</div>
          </div>
        )}
      </form>
    </div>
  );
};
